import { render, staticRenderFns } from "./RegistrationPlanPage.vue?vue&type=template&id=48342782&scoped=true&"
import script from "./RegistrationPlanPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationPlanPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPlanPage.vue?vue&type=style&index=0&id=48342782&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48342782",
  null
  
)

export default component.exports